import { ArrowRight } from "lucide-react";
import Link from "next/link";
import type { ReactNode } from "react";

import { cx } from "./cx";
import styles from "./feature-card.module.css";
import type { SectionTone } from "./section-tone";
import { Skeleton } from "./skeleton";

export interface FeatureCardProps {
  href: string;
  tone?: SectionTone;
  icon: ReactNode;
  label: string;
  stat: ReactNode;
  description: ReactNode;
  cta?: string;
  loading?: boolean;
  empty?: boolean;
  className?: string;
}

export function FeatureCard({
  href,
  tone,
  icon,
  label,
  stat,
  description,
  cta = "Open",
  loading = false,
  empty = false,
  className,
}: FeatureCardProps) {
  return (
    <Link
      href={href}
      className={cx(styles.card, className)}
      data-section={tone}
    >
      <div className={styles.top}>
        <span className={styles.icon}>{icon}</span>
        <span className={styles.label}>{label}</span>
      </div>
      <div className={cx(styles.stat, empty && styles.statEmpty)}>
        {loading ? <Skeleton className={styles.skeletonStat} /> : stat}
      </div>
      <div className={styles.desc}>
        {loading ? <Skeleton className={styles.skeletonDesc} /> : description}
      </div>
      <span className={styles.cta}>
        {cta} <ArrowRight size={13} />
      </span>
    </Link>
  );
}
